module.exports = __webpack_public_path__ + "img/1482228290.8f1b9b88.jpg";